import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import  { patch } from "../../lib/request";

export const updateAlertUser = createAsyncThunk(
  "alertUser/update",
  async ({ userId, payload }, { rejectWithValue }) => {
    try {
      const res = await patch(
        `alert-users/${userId}`,
        payload
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update alert user"
      );
    }
  }
);

const alertUserUpdateSlice = createSlice({
  name: "alertUserUpdate",
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetAlertUserUpdate(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAlertUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateAlertUser.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateAlertUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetAlertUserUpdate } = alertUserUpdateSlice.actions;
export default alertUserUpdateSlice.reducer;
